angular.module('invoice')
    .controller('InvoiceBgtGroupDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, InvoiceBgtGroup, InvoiceBgtGroupConst) {
        this.$onInit = () => {
            this.item = data
            this.packTypes = [ 'DIRECT', 'INDIRECT', 'FINANCIAL', 'CF_FUND' ]
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = InvoiceBgtGroup.update(this.item).$promise
            } else {
                promise = InvoiceBgtGroup.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(InvoiceBgtGroupConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        };
    })
